import React from 'react';
import { Box } from 'reflexbox';
import { PrivateIcon, PublicIcon, FormLabel, SwitchButton } from 'boss-ui';
import { TEAM_FIELD_HIDDEN_FROM_SCOREBOARD } from 'boss-ui/src/constants';
import SwitchHelpTooltip from './SwitchHelpTooltip';
import SwitchAndTooltipContainer from './SwitchAndTooltipContainer';


export default function HideFromScoreboardToggle({fieldValue, handleFieldChange}) {
  return (
    <Box style={{ position: 'relative' }}>
      <FormLabel>Scoreboard Visibility</FormLabel>
      <SwitchAndTooltipContainer>
        <SwitchButton
          checked={fieldValue}
          handleToggle={handleFieldChange}
          id={TEAM_FIELD_HIDDEN_FROM_SCOREBOARD}
          onIcon={<PrivateIcon />}
          offIcon={<PublicIcon />}
          onText="Hidden"
          offText="Visible"
          invertColors
        />
        <SwitchHelpTooltip tooltip_id={`${TEAM_FIELD_HIDDEN_FROM_SCOREBOARD}_tooltip`} text={
          <p>
            Whether team is visible on scoreboard.
          </p>
        } />
      </SwitchAndTooltipContainer>
    </Box>
  );
}
